export function truncate(str: string, truncate_to: number): string {
  if (str.length <= truncate_to) {
    return str;
  }
  return `${str.slice(0, truncate_to - 3)}...`;
}
